
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h18v18H0z"}}),_c('path',{attrs:{"fill":"#A5A5A5","fill-rule":"nonzero","d":"M13.932 6.654l-2.12-2.12-8.104 8.785a2 2 0 00-.522 1.175l-.153 1.68 1.544-.14a2 2 0 001.29-.636l8.065-8.744zm.679-.736l.676-.733a1.603 1.603 0 00-.044-2.22l-.041-.04a1.401 1.401 0 00-1.98.08l-.732.793 2.12 2.12zm1.339-3.66a2.603 2.603 0 01.072 3.605l-9.42 10.213a3 3 0 01-1.934.953l-2.74.25.262-2.876a3 3 0 01.783-1.762l9.514-10.314a2.401 2.401 0 013.463-.07z"}})])])
      }
    
      }
    